import React, { useCallback, useContext, useEffect } from 'react';
import FourDotLoader from 'components/FourDotLoader';
import useQueryParams from 'hooks/useQueryParams';
import AuthContext from 'providers/Auth/Auth.context';
import { useNavigate } from 'react-router-dom';
import { BUSINESS_ROUTE } from 'data/global';
import api from 'api';
import mixpanelService from 'services/mixpanelService';
import useGetMixpanelProps from 'hooks/useGetMixpanelProps';
import { getMixpanelErrorProps } from 'axiosUtils';
import { ErrorViewedProps } from 'models/MixpanelEvents';

const MagicLink: React.FC = () => {
  const { onLoginReq } = useContext(AuthContext);

  const getMixpanelProps = useGetMixpanelProps();

  const {
    params: { token },
  } = useQueryParams();

  const navigate = useNavigate();

  const errorRedirect = useCallback(
    () => navigate(BUSINESS_ROUTE, { replace: true }),
    [navigate],
  );

  useEffect(() => {
    if (!token) {
      errorRedirect();
      return;
    }

    (async () => {
      try {
        const {
          data: { redirectPath, ...authBody },
        } = await api.auth.loginWithMagicLink(token);

        onLoginReq(authBody, redirectPath);
      } catch (e) {
        mixpanelService.errorViewed(
          getMixpanelProps(getMixpanelErrorProps(e)) as ErrorViewedProps,
        );
        errorRedirect();
      }
    })();
  }, [token, errorRedirect, getMixpanelProps, onLoginReq]);

  return <FourDotLoader />;
};

export default MagicLink;
